// extracted by mini-css-extract-plugin
export default {"create":"CreateTemplate-module__create__cJFqp","text":"CreateTemplate-module__text__eNQwy"};